//
//
//
//
//
//

export default {
  name: 'c-footer'
}
